import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/menu-dropdown';
const URL = BASE_URL + '/menu-dropdown';

const getAccountDropdown = async () => {
  try {
    const response = await axios.get(`${URL}/account-dropdown`);

    if (response.status === 200 && response.data.success) {
      return response.data.data; // Return the formatted dropdown options
    } else {
      throw new Error(
        response.data.message || 'Failed to fetch account dropdown data'
      );
    }
  } catch (error) {
    console.error('Error fetching account dropdown:', error);
    throw error;
  }
};

const getBusinessUnitDropdown = async () => {
  try {
    const response = await axios.get(`${URL}/business-unit-dropdown`);
    return response.data;
  } catch (error) {
    console.error('Error fetching business unit dropdown:', error);
    throw error;
  }
};

const getProjectDropdown = async () => {
  try {
    const response = await axios.get(`${URL}/project-dropdown`);
    return response.data;
  } catch (error) {
    console.error('Error fetching project dropdown:', error);
    throw error;
  }
};

const getExternalDropdown = async () => {
  try {
    const response = await axios.get(`${URL}/external-dropdown`);
    return response.data;
  } catch (error) {
    console.error('Error fetching external dropdown:', error);
    throw error;
  }
};

const getInternalDropdown = async () => {
  try {
    const response = await axios.get(`${URL}/internal-dropdown`);
    return response.data;
  } catch (error) {
    console.error('Error fetching internal dropdown:', error);
    throw error;
  }
};

const getProjectCostDropdown = async () => {
  try {
    const response = await axios.get(`${URL}/project-cost-dropdown`);
    return response.data;
  } catch (error) {
    console.error('Error fetching project cost dropdown:', error);
    throw error;
  }
};

export {
  getAccountDropdown,
  getBusinessUnitDropdown,
  getProjectDropdown,
  getExternalDropdown,
  getInternalDropdown,
  getProjectCostDropdown,
};
